import { template } from "@babel/core";
import { ViewModel,View, ObservableArray } from "binder"
import { invalid } from "moment";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { FormBuilderWindowViewModel } from "src/formBuilder/formBuilder/formBuilderWindow-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IEditorPart } from "../processDefinition-viewModel";
import { ExportViewModel } from "./export/export-viewModel";
import { ImportViewModel } from "./import/import-viewModel";
import  { ProcessFormsView } from "./processForms-view"

export class ProcessFormsViewModel extends ViewModel implements IEditorPart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = 'فرم ساز';
        this.forms = ObservableArray.create<form>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ProcessFormsView();
    }
    public getTypeId(): string {
        return "VM-3F6973A0-6DD6-4451-B68E-D1EF554E81DF"
    }

    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set forms(v: ObservableArray<form>) { this._forms = v; } public get forms(): ObservableArray<form> { return this._forms;} private _forms: ObservableArray<form>;
    public set selectedForm(v: form) { 
        this._selectedForm = v; 
        this.onSelectedFormChanged();
    } public get selectedForm(): form { return this._selectedForm;} private _selectedForm: form;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set newFormName(v: string) { this._newFormName = v; } public get newFormName(): string { return this._newFormName;} private _newFormName: string;
    public set formPath(v: string) { this._formPath = v; } public get formPath(): string { return this._formPath;} private _formPath: string;
    
    public set formBuilder(v: FormBuilderWindowViewModel) { this._formBuilder = v; } public get formBuilder(): FormBuilderWindowViewModel { return this._formBuilder;} private _formBuilder: FormBuilderWindowViewModel;
    
    private _processId:string;
    
    async loadByProcessId(processId: string) {
        this._processId = processId;
        this.loadForms();
    }
    async loadForms(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetProcessForms',{
                ProcessId:this._processId
            });
            this.forms.update(...result.Forms.map(x=>{
                let f = new form(this);
                f.id = x.FormId;
                f.name = x.FormName;
                f.path = x.Path;
                return f;
            }));
            this.selectedForm = null;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async createForm(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/CreateProcessForm',{
                ProcessId : this._processId,
                FormName : this.newFormName
            });
            await this.messageBoxConfirmSuccess('ذخیره سازی انجام شد','دحیره سازی');
            this.loadForms();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    onSelectedFormChanged() {
        if(this.selectedForm==null){
            this.formBuilder = null;
            this.formPath = '';
        }else{
            this.formPath = this.selectedForm.path;
            this.loadForm();
        }        

    }

    async updateFormPath(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/UpdateFormPath',{
                FormId : this.selectedForm.id,
                Path : this.formPath
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async loadForm(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetFormInfo',{
                FormId : this.selectedForm.id
            });
            if(stringIsNullOrEmpty(result.FormInfo)){
                var formBuilder = new FormBuilderWindowViewModel(this);
                this.formBuilder = formBuilder;
            }else{
                let formData = JSON.parse(result.FormInfo);
                var formBuilder = new FormBuilderWindowViewModel(this);
                formBuilder.deserialize(formData);
                this.formBuilder = formBuilder;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async saveForm(){
        try {
            this.isLoading = true;
            let formData = this.formBuilder.getSerializedData();
            let shallReturn :Boolean = false;
            let templates = formData.FormData.Templates;
            formData.FormData.Templates.forEach(element => {
                if(element.Json==undefined){
                    shallReturn = true;
                    alert(element.Name);
                }
            });
            if(shallReturn==true){
                return;
            }
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/SaveForm',{
                FormId : this.selectedForm.id,
                FormName : this.selectedForm.name,
                FormData : JSON.stringify(this.formBuilder.getSerializedData()),
                FormHtml : ''
            });
            await this.messageBoxConfirmSuccess('ذخیره سازی انجام شد','دحیره سازی');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    export(){
        let exporter = new ExportViewModel(this);
        exporter.text = JSON.stringify(this.formBuilder.getSerializedData());
        this.requestShowingPopup(exporter);
    }
    async import(){
        let importer = new ImportViewModel(this);
        let result = await this.requestShowingPopup(importer);
        if(stringIsNullOrEmpty(result)==false){
            let formData = JSON.parse(result);
            var formBuilder = new FormBuilderWindowViewModel(this);
            formBuilder.deserialize(formData);
            this.formBuilder = formBuilder;
        }
    }
}

export class form extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    
    
}

// export class EmptyVm extends ViewModel{
//     public getTypeId(): string {return '';}
//     public GetDefaultView(): View<ViewModel> {return null;}
//     constructor(parent:ViewModel) {
//         super(parent);
//     }
    
    
// }